import { InputType } from 'config'

import { RESPA6_COLLECTED } from './constants'

export const canShowRespa6Date = (inputs: Record<string, InputType>): boolean => {
  const triggerDate = inputs[RESPA6_COLLECTED]?.value
  return typeof triggerDate === 'string' && !!triggerDate.trim()
}
